module.exports = {"professional-conditions":"Conditions for professionals","patient-conditions":"Conditions for patients","companies-telemedicine":"Health and well-being for companies","contact":"Contact","legal-notice":"Legal notice","faqs":"Frequently asked questions","all-rights":"All rights reserved.","lawyer-conditions":"Conditions for lawyers","client-conditions":"Conditions for clients","cookies-policy":"Cookies policy","privacy-policy":"Patient privacy policy","privacy-policy-professional":"Professional privacy policy","sgsi-policy":"SGSI Policy"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/public/footer-opensalud.json
// module id = 510
// module chunks = 117